import { FilterItem } from '@wconcept/wconcept-common/models/renewal/common';
import DynmBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/DynmBtn';
import FilterListBar from '../../_list/FilterListBar';

interface FilterBarProps {
  list: FilterItem[];
  onClickDelFilterListItem: (value: FilterItem) => void;
  onResetFilterList: () => void;
}

export const FilterBar = ({
  list,
  onClickDelFilterListItem,
  onResetFilterList,
}: FilterBarProps) => (
  <FilterListBar
    items={list.map((v: FilterItem) => (
      <DynmBtn
        key={v.code}
        mode="filter"
        text={v.name}
        active
        onClose={
          v.name
            ? () => {
                onClickDelFilterListItem(v);
              }
            : undefined
        }
      />
    ))}
    onReset={onResetFilterList}
  />
);
